import Ciudades from '../assets/data/ciudades.json'
import Departamentos from '../assets/data/departamentos.json'

interface CiudadItem {
  codigo: string
  ciudad: string
}

interface DepartamentoItem {
  Codigo: string | number
  Nombre: string
}

const ciudadPorCodigo = new Map(
  (Ciudades as CiudadItem[]).map((item) => [item.codigo, item.ciudad])
)

const departamentoPorCodigo = new Map(
  (Departamentos as DepartamentoItem[]).map((item) => {
    const raw = String(item.Codigo).trim()
    const key = /^\d+$/.test(raw) ? raw.padStart(2, '0') : raw
    return [key, item.Nombre] as const
  })
)

function text(value: unknown): string {
  if (value === null || value === undefined) return ''
  return String(value).trim()
}

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
}

function customerOf(order: Record<string, unknown>): Record<string, unknown> {
  return asRecord(order.customer)
}

function shippingOf(order: Record<string, unknown>): Record<string, unknown> {
  return asRecord(order.shippingAddress || order.shipping)
}

export function getExportFullName(order: Record<string, unknown>): string {
  const customer = customerOf(order)
  const first = text(order.first_name) || text(customer.first_name)
  const last = text(order.last_name) || text(customer.last_name)
  return `${first} ${last}`.trim()
}

export function getExportEmail(order: Record<string, unknown>): string {
  const customer = customerOf(order)
  return text(order.email) || text(customer.email)
}

export function getExportShippingAddress(order: Record<string, unknown>): string {
  const shipping = shippingOf(order)
  const line1 =
    text(shipping.address_1) ||
    text(shipping.address1) ||
    text(order.shipping_address_1) ||
    text(order.shipping_address)
  const line2 =
    text(shipping.address_2) ||
    text(shipping.address2) ||
    text(order.shipping_address_2)
  return [line1, line2].filter(Boolean).join('. ')
}

export function getExportCityCode(order: Record<string, unknown>): string {
  const shipping = shippingOf(order)
  return text(order.shipping_city) || text(shipping.city)
}

export function getExportCityName(order: Record<string, unknown>): string {
  const code = getExportCityCode(order)
  if (!code) return ''
  const byCode = ciudadPorCodigo.get(code) || ciudadPorCodigo.get(code.padStart(5, '0'))
  if (byCode) return byCode
  if (/^\d+$/.test(code)) return ''
  return code
}

function departmentCodeRaw(order: Record<string, unknown>): string {
  const shipping = shippingOf(order)
  const state = text(order.shipping_state) || text(shipping.state)
  if (state) return state
  const city = getExportCityCode(order)
  if (/^\d{4,5}$/.test(city)) return city.padStart(5, '0').slice(0, 2)
  return ''
}

export function getExportDepartmentCode(order: Record<string, unknown>): string {
  const raw = departmentCodeRaw(order)
  if (!raw) return ''
  if (/^\d+$/.test(raw)) return raw.padStart(2, '0')
  return raw
}

export function getExportDepartmentName(order: Record<string, unknown>): string {
  const code = getExportDepartmentCode(order)
  if (!code) return ''
  if (/^\d+$/.test(code)) return departamentoPorCodigo.get(code.padStart(2, '0')) || ''
  return code
}
